export default "__VITE_ASSET__BRAnCr6W__"